import * as React from 'react';

import FileSheets16 from './FileSheets16';

export const fileSheets16 = () => <FileSheets16 />;

export default {
    title: 'Icon/Fill/FileSheets16',
    component: FileSheets16,
    parameters: {
        notes: "`import FileSheets16 from 'box-ui-elements/es/icon/fill/FileSheets16';`",
    },
};
